import { getLang } from '../i18n/l10n';
import { CategoryIds } from '../types/categories';
import { SportIds } from '../types/sports';

const EventCenterBaseConfig = {
  operator: 'Winamax',
  theme: 'dark',
  env: process.env.REACT_APP_LIB_ENV || process.env.NODE_ENV === 'production' ? 'prod' : 'dev',
  version: '5.x',
  targetModule: 'full',
  language: getLang(),
  options: {
    videoPlaybackEnabled: true,
  },
  initialContext: {},
};

export const getEventCenterConfig = (sportId?: number | string, categoryId?: number | string | undefined): unknown => {
  switch (sportId) {
    case SportIds.GOLF:
      return {
        ...EventCenterBaseConfig,
        sport: 'golf',
      };

    case SportIds.MMA: {
      if (categoryId === CategoryIds.MMA_UFC) {
        return {
          ...EventCenterBaseConfig,
          targetModule: 'fight',
          sport: 'ufc',
          initialContext: {
            ...EventCenterBaseConfig.initialContext,
            view: 'Fight',
          },
        };
      }

      return null;
    }

    default:
      return null;
  }
};
